import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { setNavigationRef } from './signalr';

/**
 * SignalRNavigationHelper
 * 
 * This component sets up the navigation reference for SignalR notifications.
 * Place this component inside BrowserRouter but at the root level of your app.
 * 
 * Usage in App.js:
 * <BrowserRouter>
 *   <SignalRNavigationHelper />
 *   <YourAppRoutes />
 * </BrowserRouter>
 */
const SignalRNavigationHelper = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Set the navigation reference for SignalR to use
    setNavigationRef(navigate);

    // Cleanup on unmount
    return () => {
      setNavigationRef(null);
    };
  }, [navigate]);

  // This component doesn't render anything
  return null;
};

export default SignalRNavigationHelper;
